<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="4">
        <v-select
          v-model="selectedFile"
          :items="csvFiles"
          label="Select a flight"
          outlined
          dense
          @change="updateSelected"
        />
      </v-col>
    </v-row>

    <v-row v-if="selectedFile">
      <v-col>
        <!-- 💡 clé dynamique pour forcer le rafraîchissement -->
        <FlightPlotWithMap
          :key="selectedFile"
          :csv-url="baseUrl + selectedFile"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import FlightPlotWithMap from "./FlightPlotWithMap.vue";

export default {
  name: "GerfautSelect",
  components: { FlightPlotWithMap },
  data() {
    return {
      baseUrl: "https://observations.ipsl.fr/aeris/magic/qlooks/AIRCRAFT/Gerfaut/",
      csvFiles: [],
      selectedFile: null,
    };
  },
  async mounted() {
    try {
      const { data } = await axios.get(this.baseUrl);
      const matches = [...data.matchAll(/href="([^"]+\.csv)"/g)];
      this.csvFiles = matches
        .map((m) => m[1])
        .filter((f) => !f.includes("FlightPlan"))
        .sort()
        .reverse();

      if (this.csvFiles.length > 0) {
        this.selectedFile = this.csvFiles[0];
      }
    } catch (err) {
      console.error("Erreur lors du chargement des CSV :", err);
    }
  },
  methods: {
    updateSelected() {
      console.log("Fichier sélectionné :", this.selectedFile);
    },
  },
};
</script>
